/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PlanChartData } from './planChartData';


export interface SplineRequestDTO { 
    /**
     * Which slider value to solve for. Use the metric that matches the current plan view.
     */
    slider: SplineRequestDTO.SliderEnum;
    /**
     * Slider position passed from the UI, usually between 0 and 1.
     */
    sliderValue: number;
    /**
     * Curve points used by the optimizer to infer the target budget.
     */
    dataPoints: Array<PlanChartData>;
}
export namespace SplineRequestDTO {
    export type SliderEnum = 'sales' | 'orders' | 'roas' | 'cpo';
    export const SliderEnum = {
        Sales: 'sales' as SliderEnum,
        Orders: 'orders' as SliderEnum,
        Roas: 'roas' as SliderEnum,
        Cpo: 'cpo' as SliderEnum
    };
}


